var mockDataAll = {
  address: '48 Warwick St.',
  address2: 'Office 410',
  city: 'London',
  phone: '2037052290',
  zip: 'W1B 5AW',
  state: 'Gt Lon',
  variation: 'Variation-A',
  utilityLinks: [{
    sys: {
      id: '1'
    },
    label: 'Online Store',
    url: 'http://www.nva.com',
    dataAnalyticsValue: 'online-store'
  }, {
    sys: {
      id: '2'
    },
    label: 'Pharmacy',
    url: 'http://www.nva.com',
    dataAnalyticsValue: 'pharmacy'
  }, {
    sys: {
      id: '3'
    },
    label: 'Pet Portal',
    url: 'http://nva.com',
    dataAnalyticsValue: 'pet-portal'
  }]
};
var mockDataAllB = {
  address: '48 Warwick St.',
  address2: 'Office 410',
  city: 'London',
  phone: '2037052290',
  zip: 'W1B 5AW',
  state: 'Gt Lon',
  variation: 'variation-b',
  utilityLinks: [{
    sys: {
      id: '1'
    },
    label: 'Online Store',
    url: 'http://www.nva.com',
    dataAnalyticsValue: 'online-store'
  }, {
    sys: {
      id: '2'
    },
    label: 'Pharmacy',
    url: 'http://www.nva.com',
    dataAnalyticsValue: 'pharmacy'
  }, {
    sys: {
      id: '3'
    },
    label: 'Pet Portal',
    url: 'http://nva.com',
    dataAnalyticsValue: 'pet-portal'
  }]
};
var mockDataPhone = {
  phone: '2037052290',
  utilityLinks: [{
    sys: {
      id: '1'
    },
    label: 'Online Store',
    url: 'http://www.nva.com',
    dataAnalyticsValue: 'online-store'
  }, {
    sys: {
      id: '2'
    },
    label: 'Pharmacy',
    url: 'http://www.nva.com',
    dataAnalyticsValue: 'pharmacy'
  }, {
    sys: {
      id: '3'
    },
    label: 'Pet Portal',
    url: 'http://nva.com',
    dataAnalyticsValue: 'online-store'
  }]
};
var mockDataAddress = {
  address: '48 Warwick St.',
  address2: 'Office 410',
  city: 'London',
  zip: 'W1B 5AW',
  state: 'Gt Lon',
  utilityLinks: [{
    sys: {
      id: '1'
    },
    label: 'Online Store',
    url: 'http://www.nva.com',
    dataAnalyticsValue: 'online-store'
  }, {
    sys: {
      id: '2'
    },
    label: 'Pharmacy',
    url: 'http://www.nva.com',
    dataAnalyticsValue: 'pharmacy'
  }, {
    sys: {
      id: '3'
    },
    label: 'Pet Portal',
    url: 'http://nva.com',
    dataAnalyticsValue: 'online-store'
  }]
};
var topNavMock = {
  address: {
    line1: '48 Warwick St.',
    line2: 'Office 410',
    city: 'London',
    region: 'Gt Lon',
    postalCode: 'W1B 5AW'
  },
  phone: '2037052290',
  variation: 'Variation-A',
  utilityLinks: [{
    sys: {
      id: '1'
    },
    label: 'Online Store',
    url: 'http://www.nva.com',
    dataAnalyticsValue: 'online-store'
  }, {
    sys: {
      id: '2'
    },
    label: 'Pharmacy',
    url: 'http://www.nva.com',
    dataAnalyticsValue: 'pharmacy'
  }, {
    sys: {
      id: '3'
    },
    label: 'Pet Portal',
    url: 'http://nva.com',
    dataAnalyticsValue: 'pet-portal'
  }]
};
export { mockDataAll, mockDataAllB, mockDataAddress, mockDataPhone, topNavMock };